import React from 'react'
import { CWS_URL } from '@mote/helpers/constants'
import { useTrackMutation } from '@mote/api'
import { useLocalStoragePermission } from '@mote/helpers/browser'

export function GetMoteLink() {
  const { mutate: track } = useTrackMutation()
  const canAccessLocalStorage = useLocalStoragePermission()

  return (
    <a
      onClick={() =>
        track({
          variables: {
            event: 'Install Extension Clicked',
            referrer_user_id: canAccessLocalStorage
              ? window.localStorage.getItem('mote_referrer_user_id')
              : ''
          }
        })
      }
      href={CWS_URL}
    >
      <img
        className='mote-chromestore-button'
        src='/images/badges/ChromeWebStore_BadgeWBorder_Large.png'
        alt='Chrome Store'
        style={{ maxWidth: '230px', width: '100%' }}
      />
    </a>
  )
}
